import { fork } from 'redux-saga/effects';

import { watcher as changeMemberRoleReq } from './change-member-role-req';

export default function* root() {
  yield fork(changeMemberRoleReq);
}



// WEBPACK FOOTER //
// ./src/redux/circles/root-saga.js